function openExternalLinksInNewTab() {

	var links = document.links;
	for (var i = 0, linksLength = links.length; i < linksLength; i++) {
		if (links[i].hostname != window.location.hostname || links[i].href.substr(links[i].href.length - 4) == '.pdf') {
			links[i].target = '_blank';
		}
	}

}